//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminStepController_create,
  Response$AdminStepController_create$Status$201,
  ResponseContentType$AdminStepController_create,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminStepController_create = () =>
  useApiClientMutation<
    Params$AdminStepController_create,
    Response$AdminStepController_create$Status$201[ResponseContentType$AdminStepController_create]
  >({ method: 'AdminStepController_create' });
